/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";

function AuthenticatePage() {
  const location = useLocation();
  const [error, setError] = useState(false);

  useEffect(() => {
    const initiateAuth = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_CONNECTOR_API_URL}/api/auth/connect`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          if (data?.url) {
            window.location.href = data.url; // Redirect to the auth provider
          } else {
            setError(true);
          }
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Auth initiation failed", err);
        setError(true);
      }
    };

    initiateAuth();
  }, [location]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
      {!error ? (
        <>
          <CircularProgress />
          <Typography mt={2}>Redirecting to authentication provider...</Typography>
        </>
      ) : (
        <Typography color="error" variant="h6">
          Failed to initiate authentication.
        </Typography>
      )}
    </Box>
  );
}

export default AuthenticatePage;
